import script from "./AchievementsSort.vue?vue&type=script&setup=true&lang=js"
export * from "./AchievementsSort.vue?vue&type=script&setup=true&lang=js"

import "./AchievementsSort.vue?vue&type=style&index=0&id=48189e13&lang=scss"

const __exports__ = script;

export default __exports__